import { Component, ViewChild, ElementRef } from "@angular/core";
import { NavController, PopoverController, ModalController } from "ionic-angular";
import { Platform } from 'ionic-angular';
import { LoadingController, App, ViewController } from "ionic-angular";
import { FabContainer } from "ionic-angular";
import { HttpClientModule } from '@angular/common/http';
import { DomSanitizer } from "@angular/platform-browser";

import { ConnectorProvider } from "../../providers/connector/connector";
import { StaticConstantsProvider } from "../../providers/static-constants/static-constants";
import { RegionsPage } from "../regions/regions";
import { VariablesPage } from "../variables/variables";
import { DepthPage } from "../depths/depths";
import { PalettePage } from "../palette/palette";
import { ModalPage } from '../modal/modal';

import { ToastController } from 'ionic-angular';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { TranslateService } from '@ngx-translate/core';

import Swiper from "swiper"
import * as moment from "moment";

import 'leaflet';
import * as esri from "esri-leaflet";
import 'leaflet-velocity-ts';
import 'leaflet-boundary-canvas';
import 'leaflet.vectorgrid';

import xml2js from 'xml2js';

import * as png_decoder from '@vivaxy/png';
import { environment } from '../../providers/connector/environment';


declare var L: any;
declare var d3: any;

@Component({
    selector: 'page-home',
    templateUrl: 'home.html'
})


export class HomePage {
    @ViewChild('mapdiv') mapdiv: ElementRef;
    @ViewChild('timeline') timeline: any;
    @ViewChild('swiperwrapper') swiperwrapper: ElementRef;;
    @ViewChild('colorbar') colorbar: ElementRef;
    @ViewChild('startChip') startChip: ElementRef;
    @ViewChild('endChip') endChip: ElementRef;
    @ViewChild('footer') footer: ElementRef;

    sanitizer: DomSanitizer;

    map: any;
    masklayer: any;
    orientation: string;
    isApp = false;
    firstLoad = true;

    // *** Form conf.ini ***
    app_version: string = ''
    logo: string
    toolbar_buttons: any;
    mapfilesdir: string = null;
    map_type = 'sat' // 'hyb' //
    getfeature: boolean = true
    select_max_fcst: boolean = false

    catalogue: any;
    mapfile: string = ''
    regions: any = [];
    variables: any = [];
    timesteps: any = [];
    depths: number[] = [];
    depth: number;
    depthMin: number;
    depthMax: number;
    depthStep: number;
    baseMapSat: any;
    baseMapHyb: any;
    baseMapLabelsSat: any;
    baseMapLabelsHyb: any;
    wmsLabelsLayer: any;
    wmsLayer1: any;

    session = '';

    stations_mapfile: string = null;

    selected_leftmenu: any = {};
    selected_region: string = '';
    selected_region_prod_date: string = '';
    selected_variable_1: any = null;
    selected_variable_2: any = null;
    selected_variable_3: any = null;
    selected_curr_type: string = 'vect';
    selected_timestep: any = { "value": "", "type": "", "id": "" };
    selected_depth: number = 0;
    selected_layers_1: string = null;
    selected_layers_2: string = null;
    selected_layers_3: string = null;
    selected_bbox: L.LatLngBounds;
    rectangle_bbox: any;
    available_products: any = [];
    minzoom: number = 0;
    maxzoom: number = 0;
    dynpal: boolean = false;
    dynpal_auto: boolean = false
    min: string = '';
    max: string = '';
    minBeforeDynpal: string = '';
    maxBeforeDynpal: string = '';
    customMinPal: any = null;
    customMaxPal: any = null;
    unit: string = '';
    colorbar_URL: any;
    legendUrl: any;
    colorbar_params: string = null;
    dev_orientation: string = null;
    current_pos: number = 0;
    current_index: number = 0;
    current_day: string = ''
    current_day_string: string = ''
    current_time: string = ''
    fcst_days: any = [];
    fcst_times: any = [];
    day_index = 0
    time_index = 0
    curr_pos = 0
    rel_pos = 0
    chipWidth = 140
    nChip: number = 0;
    playing: boolean = false
    playicon = "play"
    toast = null
    layers_to_remove: any = [];
    wmsLayer1loaded: boolean = false
    lock: boolean = true
    swiper: any;
    slidesPerView: number = 0;
    showTimeline: boolean = true;

    graphModal: any = null;
    clicked = 0

    velocity: any;
    vectorlayer: any;
    mask: any;

    /** ****************************************************
     *
     * constructor
     *
     ******************************************************* */
    constructor(
        public platform: Platform,
        public nav: NavController,
        public popoverCtrl: PopoverController,
        public modalCtrl: ModalController,
        private loadingCtrl: LoadingController,
        public http: HttpClientModule,
        public conn: ConnectorProvider,
        private consts: StaticConstantsProvider,
        private screenOrientation: ScreenOrientation,
        public toastController: ToastController,
        private iab: InAppBrowser,
        public translate: TranslateService,
        public viewCtrl: ViewController,
        public appCtrl: App,
        sanitizer: DomSanitizer
    ) {

        this.sanitizer = sanitizer;

        translate.setDefaultLang('en');
        translate.use('en');

        let loading = this.loadingCtrl.create({
            spinner: "crescent",
            content: "Loading Map..."
        });
        loading.present();

        this.platform.ready().then(() => {

            // window.dispatchEvent(new Event('resize'));
            // $('#map-container').html('<div id=map></div>');

            this.slidesPerView = this.platform.width() / this.chipWidth
            this.orientation = this.screenOrientation.type;

            // Only for Browser and Android
            if (this.orientation) {
                this.screenOrientation.onChange().subscribe(
                    () => {
                        // console.log('screenOrientation.onChange()');
                        this.orientation = this.screenOrientation.type;
                        if (this.mapfile && this.selected_variable_1) this.updateColorbar("constructor 1");
                    }
                );
            }

            // Platform resized
            this.platform.resize.subscribe(() => {
                console.log('*************** platform.resized *************** ');

                this.swiper.update();

                // Only for iOS
                if (!this.orientation) {
                    if (this.mapfile && this.selected_variable_1) this.updateColorbar("constructor 2");
                }
                // $("#map").height($(window).height() - $("#header").height());
                this.map.invalidateSize();
            });



            setTimeout(() => {

                loading.dismiss();

                // let southWest = L.latLng(-180, -90),
                //     northEast = L.latLng(180, 90)
                // let bounds = L.latLngBounds(southWest, northEast);

                this.map = L.map("mapdiv", {
                    attributionControl: true,
                    worldCopyJump: true,    // https://leafletjs.com/reference-1.6.0.html#map-worldcopyjump
                    // crs: L.CRS.EPSG3857,
                    // fadeAnimation: false,
                    // maxBounds: bounds,      // https://leafletjs.com/reference-1.6.0.html#map-maxbounds
                    // center: [40, 18],
                    zoomControl: true,  //false,
                    zoomSnap: 0.25,
                    // zoom: 3,
                    minZoom: 2,
                    scrollWheelZoom: false,
                    smoothWheelZoom: true,
                    smoothSensitivity: 1,
                })
                    .on('load', e => setTimeout(() => {
                        // alert("load");
                        // console.log("onload", e);
                        this.map.invalidateSize(true);
                    }, 10)
                    )
                    .setView([40, 18], 3)
                    .on('dragend', async () => {
                        await this.checkProducts();
                    })
                    .on('zoomend', async () => {
                        await this.checkProducts();
                    })
                    .on('moveend', () => {
                        if (this.dynpal) this.setdynpal(null);
                    })
                    .on('click', (event: any) => {
                        if (this.getfeature) {
                            this.clicked++
                            console.log("Click ", this.clicked);
                            setTimeout(() => {
                                if (this.clicked == 1) {
                                    this.presentModal(event);
                                    this.clicked = 0;
                                }
                            }, 300);
                        }
                    })
                    .on('dblclick', (event: any) => {
                        this.clicked = 0;
                    })

                this.setBaseMap(this.map_type, null)


                // *** Set Swiper ***
                this.swiper = new Swiper('.swiper-container', {
                    init: false,
                    width: this.chipWidth * this.slidesPerView,
                    slidesPerView: this.platform.width() / this.chipWidth,
                    spaceBetween: 0,
                    touchEventsTarget: 'container',
                    grabCursor: true,
                    resistance: true,
                    freeMode: true,
                    mousewheel: false,
                    slideToClickedSlide: true,
                    // touchStartPreventDefault: true,
                    // simulateTouch: false,
                    preventClicks: true,
                    preventClicksPropagation: true,
                });

                this.swiper.on('touchEnd', () => {
                    // console.log("touchEnd", this.swiper.progress)
                    this.requireTiles()
                    // setTimeout(() => {
                    //     // this.footer.nativeElement.style.setProperty('bottom', "-20px", "important")
                    // }, 1000);
                });

                this.swiper.on('transitionEnd', () => {
                    // console.log("transitionEnd")
                    if (this.timesteps.length) {
                        this.selectCurrentTimestep(this.swiper.progress)
                        this.requireTiles()
                    }
                    // else console.log("NO this.timesteps.length")
                    // setTimeout(() => {
                    //   this.footer.nativeElement.style.setProperty('bottom', "-20px", "important")
                    // }, 1000);
                });

                this.swiper.on('sliderMove', () => {
                    // console.log('sliderMove', this.swiper.progress, this.swiper.translate);
                    if (this.timesteps.length) this.selectCurrentTimestep(this.swiper.progress)
                    // this.footer.nativeElement.style.setProperty('bottom', 0, "important");
                });

                this.swiper.on('init', () => {
                    //console.log('Swiper init')
                });

                this.swiper.on('touchStart', () => {
                    // this.footer.nativeElement.style.setProperty('bottom', 0, "important");
                    // console.log("--> ", this.swiper.clickedIndex, this.swiper.touches.currentX, this.swiper.touches.currentX-(this.swiper.clickedIndex+1)*this.chipWidth - 40 );   // Posizione all'interno di un Chip 0..140
                });

                this.swiper.on('click', () => {

                });

                this.getConfiguration()

            }, 100);

        });

    }



    /** ****************************************************
     *
     * Set timestep
     *
     ******************************************************* */
    setTimestep(idx) {
        //console.log("fn() setTimestep", idx)
        this.selected_timestep = this.timesteps[idx]
        // console.log("----------- setTimestep ----------- ", idx, this.timesteps[idx], this.selected_timestep, this.timesteps);
        this.swiper.init()
        this.setSwiperParms()
        this.swiper.update()
        this.onTimestepChange(this.selected_timestep);
    }

    /** ****************************************************
     *
     * Setup timeline
     *
     ******************************************************* */
    setSwiperParms() {
        //console.log("fn() setSwiperParms")
        this.nChip = this.fcst_days.length
        this.swiper.slidesPerView = this.platform.width() / this.chipWidth
        this.swiper.width = this.chipWidth * this.nChip
        this.swiper.params.slidesOffsetBefore = 40
        // this.swiper.params.slidesOffsetAfter = (this.chipWidth * (this.nChip-1)) + (this.chipWidth-40)
        if (this.platform.width() > this.swiper.width) {
            this.swiper.params.slidesOffsetAfter = (this.chipWidth * (this.nChip - 1)) + (this.chipWidth - 40)
            // console.log("CASE A",this.platform.width(),this.swiper.width, this.swiper.params.slidesOffsetAfter)
        } else {
            this.swiper.params.slidesOffsetAfter = this.platform.width() - 40
            // console.log("CASE B",this.platform.width(),this.swiper.width, this.swiper.params.slidesOffsetAfter)
        }
        //console.log(this.swiper);
    }



    /** ****************************************************
     *
     * Look for available products
     *
     ******************************************************* */
    checkProducts() {
        //console.log("fn() checkProducts")
        return new Promise(resolve => {

            this.available_products = []
            this.map.eachLayer((layer: any) => {
                if (layer.myTag && layer.myTag === "rect") {
                    this.map.removeLayer(layer)
                }
            });

            this.catalogue.regions.forEach(region => {

                let varIsIncluded: boolean = false

                // 1. verifica se la variabile selezionata esiste nel Prodotto
                region.variables.forEach(variable => {
                    // console.log("REGION: ", region.name, variable,this.selected_variable_1)
                    if (variable.title === this.selected_variable_1.title) varIsIncluded = true
                })

                // 2.a verifica se il bbox della mappa interseca il rectangle definito nel catalogue.json
                // 2.b verifica se il livello di zoom corrente è compreso nel range definito nel catalogue.json
                let tmp = region.bbox.split(" ")
                let corner1 = L.latLng(tmp[3], tmp[0])
                let corner2 = L.latLng(tmp[1], tmp[2])
                let bbox = L.latLngBounds(corner1, corner2)
                var rectOptions = {
                    color: '#FF0000',
                    weight: 1,
                    fillOpacity: 0,
                    dashArray: "5, 5, 5"
                }
                this.rectangle_bbox = L.rectangle(bbox, rectOptions);
                this.rectangle_bbox.myTag = "rect"

                // Visualizzare per debug
                //this.rectangle_bbox.addTo(this.map);

                let minZoom, maxZoom, currZoom: number = 0;
                let zoomStr = region.zoom.split(";");
                minZoom = zoomStr[0];
                maxZoom = zoomStr[1];
                currZoom = this.map.getZoom();

                // console.log("Region: ", region.name , " | Selected variable: ", this.selected_variable_1, " | varIsIncluded: ", varIsIncluded, " | currZoom: ", currZoom)
                if (this.map.getBounds().intersects(this.rectangle_bbox.getBounds())
                    && (currZoom >= minZoom && currZoom <= maxZoom)
                    && varIsIncluded) {
                    this.available_products.push(region.name)
                    // console.log("Pushing... ", region.name);
                    // console.log("Region: ", region.name , " | Selected variable: ", this.selected_variable_1, " | varIsIncluded: ", varIsIncluded)
                    // console.log("Selected variable: ", this.selected_variable_1)
                    // console.log("region.name: ", region.name)
                }
                // console.log(region);
                // console.log(region.name + ': ' + minZoom + ':' + maxZoom + ' -> ' + currZoom);
            });

            if (this.available_products.indexOf(this.selected_region) == -1) {
                // Forza la selezione del prodotto
                // console.log("SELEZIONO PRODOTTO",this.available_products[0])
                if (this.available_products.length > 0) this.onRegionChange(this.available_products[0]);
            }

            // console.log("this.available_products: ", this.available_products)
            resolve(this.available_products)
        })

    }


    /** ****************************************************
     *
     * Select current product
     *
     ******************************************************* */
    selectProduct(product) {
        //console.log("fn() selectProduct", product)
        // console.log('selectProduct: ',product);
        this.onRegionChange(product)
    }


    /** ****************************************************
     *
     * Show modal
     *
     ******************************************************* */
    presentModal(event) {
        //console.log("fn() presentModal", event)
        let timeseriesTimesteps = []
        // let timeseriesTimestepsString: String
        let timeRange: String
        let regions = this.catalogue.regions

        if (this.selected_leftmenu.name != "OBSERVATION") {

            regions.forEach((region: { variables: any; }) => {
                let variables = region.variables;
                //            console.log("variables -> ", variables);
                variables.forEach((variable: { name: string; title: string, layers: Array<object>; }) => {
                    // console.log("*********inizio**********");
                    //console.log("Var arr: ", variable);
                    // console.log("q2->",this.selected_variable_1.title);
                    // console.log("this ", this.selected_leftmenu.name);
                    // console.log("confrontare " + variable.name + " con  " + this.selected_leftmenu.name);
                    // console.log("*********fine**********");

                    // getting timeseriesTimesteps for getFeatureInfo request

                    variable.layers.forEach((layer: { name: string; title: string, timeinterval: string, subvar: string }) => {
                        //console.log("layer:", layer, this.selected_leftmenu )
                        if (layer.subvar === this.selected_leftmenu) {
                            //console.log("layer arr: ",layer)
                            if (layer.title === this.selected_variable_1.title) {
                                //console.log(layer.timeinterval)
                                timeRange = (layer.timeinterval).replace("/PT1H", "");
                                // timeRange = '2022-03-22T00:00:00Z/2022-03-24T23:00:00Z';
                            }
                        }
                    })

                })

                // variables.forEach((variable: { name: string; title: string, timeinterval: string; }) => {

                //     // getting timeseriesTimesteps for getFeatureInfo request
                //     if (variable.title === this.selected_variable_1.title) {
                //         timeRange = (variable.timeinterval).replace("/PT1H", "");
                //         timeRange = '2022-03-22T00:00:00Z/2022-03-24T23:00:00Z';

                //     }
                // })
            })
        }
        // timeseriesTimestepsString = JSON.stringify(timeseriesTimesteps)
        // let firstAndLastTimeseriesTimesteps = [{"day":"20220227","time":"06"}, {"day":"20220314","time":"00"}];
        // // firstAndLastTimeseriesTimesteps.push(timeseriesTimesteps[0]);
        // // firstAndLastTimeseriesTimesteps.push(timeseriesTimesteps[timeseriesTimesteps.length - 1]);
        // timeseriesTimestepsString = JSON.stringify(firstAndLastTimeseriesTimesteps)

        let LatLng = event.latlng.toString()
        let size = this.map.getSize();
        let height = size.y;
        let width = size.x;
        let point = this.map.latLngToContainerPoint(event.latlng, this.map.getZoom());
        let degrees2meters = function (lon: number, lat: number) {
            let x = lon * 20037508.34 / 180;
            let y = Math.log(Math.tan((90 + lat) * Math.PI / 360)) / (Math.PI / 180);
            y = y * 20037508.34 / 180;
            return [x, y]
        }
        let nELat = this.map.getBounds().getNorthEast().lat;
        let nELng = this.map.getBounds().getNorthEast().lng;
        let sWLat = this.map.getBounds().getSouthWest().lat;
        let sWLng = this.map.getBounds().getSouthWest().lng;
        sWLng = degrees2meters(sWLng, sWLat)[0];
        sWLat = degrees2meters(sWLng, sWLat)[1];
        nELng = degrees2meters(nELng, nELat)[0];
        nELat = degrees2meters(nELng, nELat)[1];
        let bbox = sWLng + ',' + sWLat + ',' + nELng + ',' + nELat
        // console.log("bbox:[",sWLng, sWLat, nELng, nELat,"]");

        let loading = this.loadingCtrl.create({
            spinner: 'crescent',
            enableBackdropDismiss: false,
            content: 'Loading Please Wait...'
        })

        loading.present()
        //console.log("timeRange in home getWMSTimeseries-> ", timeRange);
        if (this.selected_leftmenu == "MEDSEA: Relative Sea Level" || this.selected_leftmenu == "In situ EMODnet" || this.selected_leftmenu == "In situ Torre Guaceto"
        || this.selected_leftmenu == "In situ Arpa FVG") {
            //this.conn.getTimeserie(this.selected_layers_1, height, width, point.x, point.y, event.latlng.lat, event.latlng.lng, bbox, [])
            var layerForTimeseries = 'MEDSEA_20000101_20000101_0000_0_Total-Sea-Level';
            if (this.selected_leftmenu == "In situ Torre Guaceto" || this.selected_leftmenu == "In situ Arpa FVG") layerForTimeseries = this.selected_layers_1;
            this.conn.getTimeserie(layerForTimeseries, height, width, point.x, point.y, event.latlng.lat, event.latlng.lng, bbox, [])
                .then(response => {
                    let data: any = response
                    // console.log("modal...", data.length)
                    if (data.length > 0) {
                        this.graphModal = this.modalCtrl.create(ModalPage, {
                            data: data,
                            var: this.selected_variable_1,
                            LatLng: LatLng,
                            Steps: timeseriesTimesteps
                        });
                        this.graphModal.present();
                    } else {
                        this.conn.showAlert("Attention", "No data available!")
                    }
                    loading.dismiss();
                })
                .catch(err => {
                    loading.dismiss();
                    this.conn.showAlert("Error", "Error retrieving timeseries data")
                });

        } else {
            this.conn.getWMSTimeseries(this.selected_layers_1, height, width, point.x, point.y, bbox, timeRange)
                .then(response => {
                    let data: any = response;
                    // creating a datetime string in order to retrieve the current timestep 
                    // in modals.plotOneDataset method
                    var currentDateTimeString = this.current_day_string + "T" + this.current_time + ":00:00+00:00";
                    //console.log(data);
                    if (data.features.length > 1) {

                        this.graphModal = this.modalCtrl.create(ModalPage, {
                            data: data.features,
                            var: this.selected_variable_1,
                            LatLng: LatLng,
                            Steps: timeseriesTimesteps,
                            currentDateTimeString: currentDateTimeString
                        });
                        this.graphModal.present();
                    } else {
                        this.conn.showAlert("Attention", "No data available!")
                    }
                    loading.dismiss();
                })
                .catch(err => {
                    loading.dismiss();
                    this.conn.showAlert("Error", "Error retrieving timeseries data")
                });
        }
    }


    /** ****************************************************
     *
     * select Current Timestep
     *
     ******************************************************* */
    selectCurrentTimestep(progress: number) {
        //console.log("fn() selectCurrentTimestep", progress)
        let selected_day = null
        let selected_time = null
        this.nChip = this.fcst_days.length

        if (progress >= 0 && progress <= 1) {

            let relpos = ((this.nChip * this.chipWidth * progress) % (this.chipWidth))
            // console.log("\n\n",relpos, progress, this.nChip * this.chipWidth * progress);

            // DAY index
            let day_idx = Math.floor((progress) / (1 / this.nChip))
            //let last_available_date = this.selected_variable_1.timeinterval.split("/")[1].split("T")[1].split(":")[0];
            // console.log("DAY: ", day_idx);

            // TIMESTEP
            let timestep = Math.floor(relpos / ((this.chipWidth) / 24))

            // To select the last available timestep of the end date in the given time range
            // let last_available_timestep = this.selected_variable_1.timeinterval.split("/")[1].split("T")[1].split(":")[0];
            //if(timestep !== last_available_timestep)
            //  timestep = last_available_timestep;

            // console.log("TIMESTEP: ", timestep);

            selected_day = this.fcst_days[day_idx]
            // console.log(this.fcst_days)

            if (selected_day) {
                this.current_day = selected_day.day
                this.current_day_string = this.current_day.substring(0, 4) + '-' + this.current_day.substring(4, 6) + '-' + this.current_day.substring(6, 8);

                // console.log("selected_day.day+this.pad(timestep,2,0)",selected_day.day+this.pad(timestep,2,0));
                let selected_box = document.getElementById(selected_day.day + this.pad(timestep, 2, 0));
                if (selected_box) {
                    // console.log("TIMESTEP --> : ", selected_box,selected_box.id, selected_box.dataset.timestep );
                    selected_time = selected_box.dataset.timestep.substr(8, 2)
                    this.current_time = selected_time
                }

            }

        }

    }

    /** ****************************************************
     *
     * setTimelinePosition
     *
     ******************************************************* */
    setTimelinePosition(timestepid: any) {
        //console.log("fn() setTimelinePosition", timestepid)
        // console.log("setTimelinePosition", this.chipWidth,timestepid);
        let el = null
        let pos = 40

        let left = 0
        let offset = -1 * (pos + 17 * 2)  // -74 //-40-17 // OffsetLeft + dayWidth * 2

        this.swiper.setTranslate(pos) // reset to 40
        this.swiper.update();

        for (let i = this.fcst_days.length - 1; i >= 0; i--) {
            // console.log("fcst_days",this.fcst_days[i]);
            for (let j = this.fcst_days[i].times.length - 1; j >= 0; j--) {
                // console.log("times",this.fcst_days[i].times[j].hour);
                let curr = this.fcst_days[i].day + this.fcst_days[i].times[j].hour               

                if (curr == timestepid) {
                    el = document.getElementById(curr);
                    //console.log("INSIDE curr == timestepid",timestepid,curr,el)
                    left = el.getBoundingClientRect().left + 3 // +3 empirico
                    // console.log("LEFT 1", left, el);
                    // console.log("INSIDE Element class",el.className)
                    if (el.className == "hidden") {
                        const hidden_left = ["00", "03", "06", "09", "12", "15", "18", "21"];
                        const hidden_right = ["02", "05", "08", "11", "14", "17", "20", "23"];
                        let hour = el.id.substring(8)
                        if (hidden_left.indexOf(hour) !== -1) {
                            // console.log("HIDDEN LEFT", hour, left, el.id, el);
                            left -= 6
                        } else if (hidden_right.indexOf(hour) !== -1) {
                            // console.log("HIDDEN RIGHT", hour, left, el.id, el);
                            left -= 12
                        }
                    }

                    pos = (left + offset) * -1
                    this.swiper.setTranslate(pos)
                    this.swiper.update();
                    this.swiper.updateProgress()
                    this.selectCurrentTimestep(this.swiper.progress)
                    this.requireTiles()
                }
            }
        }
    }

    /** ****************************************************
     *
     * getLeftCoord
     *
     ******************************************************* */
    getLeftCoord(el: { getBoundingClientRect: () => { left: any; }; }) {
        //console.log("fn() getLeftCoord", el)
        return el.getBoundingClientRect().left
    }

    /** ****************************************************
     *
     * Require tiles from Mapserver/Mapcache
     *
     ******************************************************* */
    requireTiles() {
        //console.log("fn() requireTiles")
        if (this.swiper.progress > 0 && this.swiper.progress < 1) {
            // console.log("Selected day time: ", this.current_day, this.current_time)
            let curr_timestep = {
                value: this.current_day + " " + this.current_time + "00",
                type: "",
                id: this.current_day + "" + this.current_time
            };
            this.selected_timestep = curr_timestep;
            this.onTimestepChange(this.selected_timestep);
        }
    }

    /** ****************************************************
     *
     * Set/Unset dynamic palette
     *
     ******************************************************* */
    setdynpal($event: any) {
        //console.log("fn() setdynpal")
        let time = moment(this.selected_timestep.value, 'YYYYMMDD HH')

        if (this.dynpal) {

            let latmax = this.map.getBounds()._northEast.lat
            let latmin = this.map.getBounds()._southWest.lat
            let lonmax = this.map.getBounds()._northEast.lng
            let lonmin = this.map.getBounds()._southWest.lng
            let minPal = this.minBeforeDynpal
            let maxPal = this.maxBeforeDynpal

            let customMinPal = this.customMinPal
            let customMaxPal = this.customMaxPal

            let pdate = this.selected_region_prod_date;

            this.conn.getDynData(this.selected_layers_1, latmin, latmax, lonmin, lonmax, minPal, maxPal, customMinPal, customMaxPal, this.session, pdate)
                .then(data => {
                    console.log('getDynData: ', data);
                    this.session = data['session']
                    this.wmsLayer1.setParams({
                        map: data['mapfile'],
                        time: time.format('YYYY-MM-DDTHH:00:00')
                    });
                    this.min = data['min'];
                    this.max = data['max'];

                    if (this.mapfile && this.selected_variable_1) this.updateColorbar("setdynpal 1");
                });
        } else {
            this.mapfile = this.mapfilesdir + this.selected_region + '.map';

            this.wmsLayer1.setParams({
                map: this.mapfile,
                time: time.format('YYYY-MM-DDTHH:00:00')
            });
            this.min = this.minBeforeDynpal;
            this.max = this.maxBeforeDynpal;
            if (this.mapfile && this.selected_variable_1) this.updateColorbar("setdynpal 1");
        }
    }


    /** *********************************************************
     *
     * zoomendEvent
     *
     * ******************************************************* */
    // zoomendEvent(ev: any) {
    //     console.log("Zoom: ",this.map.getZoom());
    // }


    /** ****************************************************
     *
     * ionViewDidLoad
     *
     * ******************************************************* */
    // ionViewDidLoad() {

    // }

    /** ****************************************************
     *
     * Update the colorbar
     *
     **************************************************** */
    updateColorbar(caller) {
        //console.log("fn() updateColorbar:", caller)

        // Only for Browser and Android
        if (this.orientation) {
            if (this.orientation == 'landscape-primary' || this.orientation == 'landscape-secondary' || this.orientation == 'landscape')
                this.dev_orientation = 'h';
            else
                this.dev_orientation = 'v';
        }
        // Only for iOS
        else {
            if (this.platform.isLandscape()) this.dev_orientation = 'h';
            else this.dev_orientation = 'v';
        }

        // for Total Sea Level product
        if (this.selected_variable_1.title == "MEDSEA_20000101_20000101_0000_0_Total-Sea-Level") {
            this.colorbar_URL = undefined;
            this.showTimeline = false;
        }        
        // for all the other products
        else {
            if (this.selected_variable_1['name'] == 'NiN:Wave-Height') {
                this.colorbar_URL = this.sanitizer.bypassSecurityTrustResourceUrl("https://ncwms.cmcc-opa.eu/ncWMS/wms?REQUEST=GetLegendGraphic&PALETTE=default&LAYERS=NiN:Wave-Height/vhm0&STYLES=default-scalar/x-Rainbow&width=51&height=240");
            } else if (this.selected_variable_1['name'] == 'NiN:Wave-Period'){
                this.colorbar_URL = this.sanitizer.bypassSecurityTrustResourceUrl("https://ncwms.cmcc-opa.eu/ncWMS/wms?REQUEST=GetLegendGraphic&PALETTE=default&LAYERS=NiN:Wave-Period/vtza&STYLES=default-scalar/x-Rainbow&width=51&height=240");
            }
            else this.colorbar_URL = this.sanitizer.bypassSecurityTrustResourceUrl(this.legendUrl+"&width=51&height=240");
        }
    }

    /** ****************************************************
     *
     * Retrieve Configuration
     *
     ******************************************************* */
    getConfiguration() {
        //console.log("fn() getConfiguration")
        this.conn.getConfiguration().then(data => {
            this.app_version = this.conn.app_version
            this.logo = this.conn.logo
            this.toolbar_buttons = this.conn.toolbar_buttons
            this.mapfilesdir = this.conn.mapfilesdir;
            this.stations_mapfile = this.conn.stations_mapfile;
            this.map_type = this.conn.map_type
            this.getfeature = this.conn.getfeature
            this.select_max_fcst = this.conn.select_max_fcst
            document.title = this.conn.app_name
            // console.log("--- getConfiguration in Home: ", data);
            this.getCatalogue()
        })
    }

    /** ****************************************************
     *
     * Retrieve the json catalogue
     *
     ******************************************************* */
    getCatalogue() {
        //console.log("fn() getCatalogue")
        this.conn.getCatalogue().then(async data => {   // fa una richiesta GetCapabilities a Mapserver

            this.parseCapabilities(data).then((data) => {
                this.catalogue = data;
                let regions = this.catalogue.regions; 
                regions.forEach((region: any) => {
                    this.regions.push(region.name);
                });
                console.log('*info* Right menu, this.catalogue: ', this.catalogue);
                // console.log('this.regions: ', this.regions );
                this.selected_region = this.regions[0];
                this.onRegionChange(this.selected_region);
                this.checkProducts();

            });
        });

        // Invoked everytime left menu chnages
        this.conn.invokeOnVariable.subscribe(selected => {
            this.selected_leftmenu = selected;
            this.onRegionChange(this.selected_region);
        });
    }


    /** ****************************************************
     * Parse GetCapabilities response
     * @param xml
     ******************************************************* */
    parseCapabilities(data) {
        //console.log("fn() parseCapabilities")
        return new Promise(resolve => {
            // let _layers = []
            let parser = new xml2js.Parser({
                trim: true,
                explicitArray: true
            });

            parser.parseString(data, function (err, result) {

                // ****************  BEGIN: monoregion ******************************************
                let ret = {}

                // console.log('parseXML', result);
                let WMS_Capabilities = result.WMS_Capabilities;
                // console.log('parseXML', WMS_Capabilities);
                let Capability = WMS_Capabilities.Capability;
                // console.log('parseXML Capability', Capability);
                let MainLayer = Capability[0].Layer;
                // console.log('parseXML WMS_CMCC MainLayer ', MainLayer);

                //bbox adjusted to ADRI area
                ret['regions'] = []
                ret['regions'][0] = {
                    name: 'CASCADE',
                    bbox: '11.225 38.305 21.580 46.510',
                    zoom: '4;6'
                };


                ret['regions'][0]['variables'] = []
                let varLayer = [];
                let _variables = MainLayer[0].Layer;

                //Arrange layers (temp, current, ..) present inside variables(gofs, medfs, ..)
                for (let j = 0; j < _variables.length; j++) {
                    let _variable = _variables[j]
                    let _layers = [];
                    if (_variable.Layer) {
                        for (let k = 0; k < _variable.Layer.length; k++) {
                            let _layer = _variable.Layer[k];
                            _layers[k] = {
                                name: _layer.Name[0],
                                title: _layer.Title[0],
                                subvar: convertString(_layer.Name[0].split(":")[0]),
                                timeinterval: _layer.Dimension ? _layer.Dimension[0]['_'] : '',
                                legendUrl: _layer.Style ? _layer.Style[0]['LegendURL'][0]['OnlineResource'][0]['$']['xlink:href'] : ''
                            };
                        }                        
                        varLayer[j] = _layers
                    }
                    else {
                        varLayer[j] = [];
                    }
                    varLayer[j].sort(function (a, b) {
                        return a.title.localeCompare(b.title);
                    });
                }
                //console.log('parseXML Variable Layer', varLayer);

                for (let j = 0; j < _variables.length; j++) {
                    let _variable = _variables[j]
                    ret['regions'][0]['variables'][j] = {
                        name: _variable.Name[0],
                        title: _variable.Title[0],
                        //timeinterval: _variable.Dimension ? _variable.Dimension[0]['_'] : 0,
                        layers: varLayer[j]
                    }
                }

                // console.log('RET --> ', ret)
                resolve(ret);
                // ******************  END: monoregion ******************************************






                // ****************  BEGIN: multiregion ******************************************

                // // console.log('parseXML', result);
                // let WMS_Capabilities = result.WMS_Capabilities;
                // // console.log('parseXML', WMS_Capabilities);
                // let Capability = WMS_Capabilities.Capability;
                // // console.log('parseXML Capability', Capability);

                // // Da MainLayer prendere dati REGION: name, bbox, prod_date, zoom
                // let MainLayer = Capability[0].Layer;
                // console.log('parseXML WMS_CMCC MainLayer ', MainLayer);

                // let ret = {}
                // ret['regions'] = []

                // let _regions = MainLayer[0].Layer;
                // // console.log('parseXML Region Layer', _regionLayer[i].Name[0]);//, _regionLayer);
                // console.log('parseXML # of Regions', _regions.length);

                // for (let i=0; i<_regions.length; i++) {

                //     let _region = _regions[i]
                //     // console.log('parseXML Region '+(i+1)+' Layer Name:', _region.Name[0]);
                //     ret['regions'][i] = {
                //         name: _region.Title[0],
                //         bbox: '-90 -90 90 90',
                //         zoom: '1;20'
                //     };

                //     ret['regions'][i]['variables'] = []
                //     let _variables = _region.Layer
                //     console.log('parseXML _variables', _variables);

                //     for (let j=0; j<_variables.length; j++) {
                //         let _variable = _variables[j]
                //         // console.log('parseXML Variable Layer', _variable, _variable.Name);
                //         // console.log('parseXML Variable Layer', _variable);

                //         // let tmp_depth = _variable.Layer[0].Name[0].split("_")[2]
                //         // console.log('parseXML Variable Layer DEPTH', _region.Title[0], _variable.Layer[0].Title[0],tmp_depth);

                //         ret['regions'][i]['variables'][j] = {
                //             name: _variable.Layer[0].Name[0],
                //             title: _variable.Layer[0].Title[0],
                //             timeinterval: _variable.Layer[0].Dimension ? _variable.Layer[0].Dimension[0]['_'] : 0,
                //         }

                //     }                   

                // }

                // // console.log('RET --> ', region_arr)
                // console.log('RET --> ', ret)

                // resolve(ret);
                // ****************  END: multiregion ******************************************

            });
        });
    }

    /** ****************************************************
     * Called when Region change
     * @param region element
     ******************************************************* */
    onRegionChange(el: string) {
        //console.log('fn() onRegionChange Element: ', el);
        console.log("catalogo in regionChange ", this.catalogue)
        this.clearLayers();
        this.selected_region = el;
        this.variables = [];
        this.selected_bbox = null;
        this.selected_depth = 0;

        let regions = this.catalogue.regions;

        // Default left menu selection
        if (Object.keys(this.selected_leftmenu).length === 0) {
            this.selected_leftmenu = regions[0].variables[0].layers[0].subvar;
        }

        regions.forEach((region: any) => {
            // console.log('region: ', el, region);
            if (this.selected_region === region.name) {
                let regVariables = region.variables
                regVariables.forEach((regVariable: any) => {
                    // Check if variable already exists in 'this.variables' array
                    // let tmpRegArr = this.variables.filter(el => el.title == regVariable.title)

                    //console.log("regVariable", regVariable);

                    //regVariable.vartype = regVariable.vartype ? regVariable.vartype : 'ocean'
                    // if (regVariable.title.indexOf('Direction') < 0 &&
                    //     regVariable.title.indexOf('Vector') < 0 && 
                    //     tmpRegArr.length === 0)
                    //     this.variables.push({ "name": regVariable.name, "title": regVariable.title, "type": regVariable.vartype });

                    let varLayersArr = [];
                    regVariable.layers.forEach((varLayer: any, i) => {
                        if (this.selected_leftmenu == varLayer.subvar) {
                            varLayersArr.push(varLayer);
                        }
                    });
                    // console.log(varLayersArr);

                    /** only the layers of the left menu variable selection is added */
                    if (varLayersArr.length !== 0)
                        this.variables.push({ "name": this.selected_leftmenu, "title": this.selected_leftmenu, "layers": varLayersArr, "type": "ocean" });

                    // if (tmpRegArr.length === 0 && this.selected_leftmenu.name == regVariable.name)
                    //this.variables.push({ "name": regVariable.name, "title": regVariable.title, "layers": regVariable.layers, "type": regVariable.vartype });
                    // console.log('variable.title: ', regVariable.name);
                });

                // this.variables.sort(function (a, b) {
                //     return a.title.localeCompare(b.title);
                // });
                // console.log(this.variables)
                this.selected_region_prod_date = region.prod_date;

                // BBOX
                if (region.bbox) {
                    let tmp = region.bbox.split(" ")
                    let corner1 = L.latLng(tmp[3], tmp[0])
                    let corner2 = L.latLng(tmp[1], tmp[2])
                    this.selected_bbox = L.latLngBounds(corner1, corner2)
                }

                // min/max zoom
                if (region.zoom) {
                    let tmpzoom = region.zoom.split(";");
                    // console.log('ZOOM: ',tmpzoom);
                    this.minzoom = parseInt(tmpzoom[0]);
                    this.maxzoom = parseInt(tmpzoom[1]);
                }
            }
        });

        // console.log(JSON.stringify(this.selected_bbox));
        // console.log("VARIABLES: ", (this.variables));

        this.setBaseMap(this.map_type, null);
        this.map.fitBounds(this.selected_bbox, { padding: [50, 50] });

        //if (this.firstLoad) {
        // console.log("fitBoundsfitBoundsfitBounds",this.firstLoad, step)
        // this.map.fitBounds(this.selected_bbox, { padding: [50, 50] });
        // this.firstLoad = false
        //}
        
        // Updating variable selection with change in left menu
        if (this.selected_variable_1 == null)
            this.selected_variable_1 = this.variables.filter(element => !element.title.includes("Direction") && !element.title.includes("Vector"))[0]
           //&& !element.title.includes("Wave-Direction/vdir"))[0]
        else
            this.selected_variable_1 = this.variables[0];
        // console.log("selected_variable_1: ", this.selected_variable_1)
        // this.selected_variable_1 = this.variables[0];

       if (this.selected_variable_1.layers[0]['name'] == 'NiN:Wave-Direction')  this.onVariableChange(this.selected_variable_1.layers[1], undefined);
        else 
            {// Default layer selection
                this.onVariableChange(this.selected_variable_1.layers[0], this.selected_curr_type);
            }
    }


    /** ****************************************************
     * onVariableChange
     * @param variable element
     *
     ******************************************************* */
    async onVariableChange(variable1: string, curr_type: string) {
        //console.log('fn() onVariableChange Element: ', variable1);

        this.clearLayers();
        this.removeCurrentsAnimationLayer()
        this.swiper.removeAllSlides();

        this.dynpal = false
        this.dynpal_auto = false

        this.selected_variable_1 = variable1;
        this.selected_variable_2 = null;
        this.selected_variable_3 = null;
        this.selected_curr_type = curr_type

        this.timesteps = [];
        this.depths = [];
        // this.selected_depth = 0;

        this.checkProducts()
        this.selected_variable_2 = null;
        this.selected_variable_3 = null;
        let filtered_list: any = {}
        
        switch (this.selected_variable_1.title.split(":")[1]) {
            case 'Currents':

                filtered_list = this.variables[0].layers.filter((element: any) => {
                    return (element.title == this.selected_leftmenu+':Currents-Vector' || element.title == this.selected_leftmenu+':Currents-Direction')
                });
                this.selected_variable_2 = filtered_list[0];
                break;

            case 'Wind':
                filtered_list = this.variables[0].layers.filter((element: any) => {
                    return (element.title == this.selected_leftmenu+':Wind-Direction')
                });
                this.selected_variable_2 = filtered_list[0]
                break;

            case "Wind-Wave-Period":
            case "Wind-Wave-Height":
                filtered_list = this.variables[0].layers.filter((element: any) => {
                    return (element.title == this.selected_leftmenu+':Wind-Wave-Direction')
                });
                this.selected_variable_2 = filtered_list[0]
                break;

            case 'Wave-Period':
                filtered_list = this.variables[0].layers.filter((element: any) => {
                    return (element.title == this.selected_leftmenu+':Wave-Direction')
                });
                this.selected_variable_2 = filtered_list[0]
                break;

            case 'Wave-Height':
                filtered_list = this.variables[0].layers.filter((element: any) => {
                    return (element.title == this.selected_leftmenu+':Wave-Direction')
                });
                this.selected_variable_2 = filtered_list[0]
                break;

            case 'Ice-Velocity':
                filtered_list = this.variables[0].layers.filter((element: any) => {
                    return (element.title == this.selected_leftmenu+':Ice-Direction')
                });
                this.selected_variable_2 = filtered_list[0]
                break;

            case 'Wind-Stress':
                filtered_list = this.variables[0].layers.filter((element: any) => {
                    return (element.title == this.selected_leftmenu+':Wind-Stress-Direction')
                });
                this.selected_variable_2 = filtered_list[0]
                break;

            case 'Temperature':
                break;

            case 'Sea-Surface-Height':
                break;

            case 'Swell-Period':
            case 'Swell-Height':
                filtered_list = this.variables[0].layers.filter((element: any) => {
                    return (element.title == this.selected_leftmenu+':Swell-Direction')
                });
                this.selected_variable_2 = filtered_list[0]
                break;
            case 'Oxygen-Concentration':
                filtered_list = this.variables[0].layers.filter((element: any) => {
                    return (element.title == this.selected_leftmenu.replace(/-/g, " ")+':Oxygen-Concentration')
                });
                this.selected_variable_2 = filtered_list[0]
                break;
            case 'Wave-Height/vhm0':
            case 'Wave-Period/vtza':
                filtered_list = this.variables[0].layers.filter((element: any) => {
                    return (element.title == 'NiN:Wave-Direction/vdir')
                });
                this.selected_variable_2 = filtered_list[0]
                break;
            default:
                this.selected_variable_2 = null;
                this.selected_variable_3 = null;
        }

        //console.log(this.selected_variable_1);
        if(this.selected_variable_1.subvar == "Satellite"){
           // console.log("satellite is here")
        }
        this.showTimeline = true;
        this.swiper.removeAllSlides()
        let regions = this.catalogue.regions;

        regions.forEach((region: any) => {
            if (this.selected_region === region.name ) {
                let variables = region.variables;
                // console.log(variables);
                variables.forEach((variable: any) => {
                    variable.layers.forEach((layer: any) => {
                        // console.log('*info* layer:' , layer, this.selected_variable_1);
                        
                        if (this.selected_variable_1.name === layer.name) {
                            this.fcst_days = []
                            this.min = "0"    //variable.min
                            this.max = "1.0"   //variable.max
                            this.minBeforeDynpal = '999'         // this.min;
                            this.maxBeforeDynpal = '999'         // this.max;
                            this.unit = variable.unit
                            // let products = variable.products;

                            //only if the timeinterval exist we do the calculations related to swiper
                            if (layer.timeinterval != '') {
                                let timeinterval = layer.timeinterval;
                                
                                this.legendUrl = layer.legendUrl;

                                timeinterval = timeinterval.split('/');
                                let startDate = timeinterval[0]
                                let endDate = timeinterval[1]
                                let endDateTime = Number(endDate.split("T")[1].split(":")[0]);

                                //to store if the timestep is 1D or 1H
                                let timestepnumber = timeinterval[2];
                                

                                //if the enddate's time just has value at 00:00, we skip that date from swiper
                                if (endDateTime == 0)
                                    endDate = moment(endDate).subtract(1, 'days');

                                let numberOfDays = this.daysBetween(startDate, endDate);
                                // console.log("numberOfDays",numberOfDays)

                                // ********** Set depths array for this variable *********
                                // let tmp_depth = variable.name.split("_")[2]
                                // // console.log("tmp_depth", tmp_depth)
                                // this.depths.push(parseInt(tmp_depth))
                                // this.depths.sort(function(a, b) {
                                //     return a - b;
                                // });
                                // console.log("this.depths", this.depths)

                                // ********** ********************************** *********

                                let daysclass = ""
                                let idx = 0

                                // Days
                                for (var m = moment(startDate); m.diff(endDate, 'days') <= 0; m.add(1, 'days')) {
                                    // console.log(m.format('ddd, D MMM'));

                                    if (idx == 0) daysclass = "dayfirst"
                                    else if (idx > 0 && idx < numberOfDays - 1) daysclass = "daymiddle"
                                    else if (idx == numberOfDays - 1) daysclass = "daylast"

                                    let slide = ''
                                    slide += '<div class="swiper-slide">'
                                    let dayid = m.format('YYYYMMDD')
                                    slide += '<ion-chip id=' + dayid + '>'
                                    let date = m.format('ddd, D MMM')       //moment(date_str).format("ddd, D MMM");
                                    slide += '<ion-label class=' + daysclass + '><span class="daytxtclass">' + date + '</span>';
                                    slide += '<br>'

                                    // Add timesteps in swiper for only the available data
                                    let lastTimestep = 23;
                                    if (moment(endDate).format('YYYYMMDD') == m.format('YYYYMMDD') && endDateTime != 0)
                                        lastTimestep = endDateTime;
                                    else if(timestepnumber == "PT1D")
                                        lastTimestep = 0;
                                    else
                                        lastTimestep = 23;

                                    for (let i = 0; i <= lastTimestep; i++) {

                                        let timestep = { hour: this.pad(i, 2, 0), type: 'forecast' }
                                        this.fcst_times.push(timestep)
                                        let timestepid = dayid + timestep.hour

                                        this.timesteps.push(
                                            {
                                                "value": dayid + ' ' + timestep.hour + '00',
                                                "type": 'forecast',
                                                "id": dayid + timestep.hour
                                            }
                                        );

                                        if (i % 3 == 1) {
                                            slide += '<span data-timestep="' + timestepid + '" id=' + timestepid + ' class="time forecast" >' + this.pad(i, 2, 0) + '</span>'
                                        } else {
                                            slide += '<span data-timestep="' + timestepid + '" id=' + timestepid + ' class="hidden" >' + this.pad(i, 2, 0) + '</span>'
                                        }

                                    }

                                    slide += '</ion-label>'
                                    slide += '</ion-chip>'
                                    slide += '</div>'

                                    this.swiper.appendSlide(slide);
                                    this.fcst_days.push({ day: dayid, times: this.fcst_times })
                                    this.fcst_times = []

                                    idx++
                                    //console.log(slide);

                                }
                            }
                        }
                    });
                });

            }

        });


        // --------------------------------------------------------------------------

        let todaytimestep = null;

        // Set TODAY as current timestep only if selected_timestep is empty (first load)!
        if (this.selected_timestep.id === '') {
            // console.log("selected_timestep.id is empty! Set as today")
            let date = new Date();
            let ts_date = date.getUTCFullYear() + '' + ("0" + (date.getUTCMonth() + 1)).slice(-2) + '' + ("0" + date.getUTCDate()).slice(-2);
            let ts_time = ("0" + (date.getUTCHours() + 1)).slice(-2);
            todaytimestep = ts_date + ts_time

            //console.log("*info* Timesteps", this.timesteps);
            for(const element of this.timesteps)  {
                 //console.log('element.id --> ', element.id)

                 /** If today doesnt exist in timestep, set as first value of timestep */
                this.selected_timestep.id = this.fcst_days[0].day + this.fcst_days[0].times[0].hour;
                this.selected_timestep.type = "forecast";
                this.selected_timestep.value = this.fcst_days[0].day + " " + this.fcst_days[0].times[0].hour + "00";

                /** If today exist update selected timestep and break out of loop */
                if (element.id === todaytimestep) {
                    //console.log('Found --> ', element.id,todaytimestep)
                    this.selected_timestep = element;
                    break;
                }
            }
            
            todaytimestep = this.selected_timestep.id
            console.log('*info* Today UTC: ', todaytimestep);
        } 
        else {
            todaytimestep = this.selected_timestep.id;
            //if selected model is not insitu or medea relative sea level
            if(this.timesteps.length!=0){
                let isTimeStepPresent = false;
                for(const element of this.timesteps)  {
                    if (element.id === todaytimestep) {
                        isTimeStepPresent = true;
                    }
                }
                //if the timestep is not present in timeline set it as first timestep value
                if(!isTimeStepPresent)
                    todaytimestep = this.timesteps[0].id;
            }
        }

        console.log('*info* Selected timestep: ', this.selected_timestep);

        // Do not move to init()
        this.swiper.init()
        this.setSwiperParms()
        this.swiper.update()

        this.setTimelinePosition(todaytimestep);
        this.onTimestepChange(this.selected_timestep);  
        if (this.dynpal) this.setdynpal(null);

        // console.log("this.timesteps", this.timesteps);

    }


    /** ****************************************************
     *
     * Pad with leading zeros
     *
     ******************************************************* */
    pad(n, width, z) {
        //console.log('fn() pad')
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    /** ****************************************************
     *
     * Called when the timestep change
     * @param timestep element
     *
     ******************************************************* */
    onTimestepChange(el: any) {
        //console.log("fn() onTimestepChange", el)
        // console.log('onTimestepChange Element: ', el );
        // return;
        this.selected_timestep = el;
        // this.timesteps = [];
        //this.selected_depth = '0';
        let regions = this.catalogue.regions;
        regions.forEach((region: any) => {
            if (this.selected_region === region.name) {
                // console.log('\n\nregion: ', this.selected_region, region );
                let variables = region.variables;

                variables.forEach((variable: any) => {
                    if (this.selected_variable_1.title === variable.title) {
                        // console.log('variable: ', variable );

                        this.min = variable.min
                        this.max = variable.max
                        this.unit = variable.unit


                        // let products = variable.products;
                        // products.forEach((forecast: any) => {
                        //     // console.log('forecast: ', forecast );
                        //     this.timesteps.push({
                        //         "value": forecast.day + ' ' + forecast.time + '00',
                        //         "type": forecast.type,
                        //         "id": forecast.day + forecast.time
                        //     });

                        //     if (this.selected_timestep.value === forecast.day + " " + forecast.time + "00") {
                        //         this.depths = forecast.depths;
                        //         if (this.depths) {
                        //             if (this.depths.indexOf(this.selected_depth) == -1)
                        //                 this.selected_depth = this.depths[0];
                        //         }
                        //     }
                        // });
                    }
                });
            }
        });
        if (this.depths.indexOf(this.selected_depth) == -1) this.selected_depth = this.depths[0];

        this.onDepthChange(this.selected_depth);
    }

    /** ****************************************************
     *
     * Called when Depth change
     * @param depth element
     *
     ******************************************************* */
    onDepthChange(el: number) {
        //console.log('fn() onDepthChange', el)
        // console.log('onDepthChange Element: ', el, this.depths );
        this.selected_depth = el;
        this.setMap();  // Fa partire la richiesta di aggiornamento tiles
        if (this.dynpal) this.setdynpal(null);
    }


    /** ****************************************************
     *
     * Set base maps (Hybrid, Sat, Labels)
     * @param type
     * @param fab
     *
     ******************************************************* */
    setBaseMap(type: string, fab: FabContainer = null) {
        //console.log("fn() setBaseMap", type)
        this.map_type = type;

        if (this.baseMapHyb) this.map.removeLayer(this.baseMapHyb)
        if (this.baseMapSat) this.map.removeLayer(this.baseMapSat)
        if (this.baseMapLabelsSat) this.map.removeLayer(this.baseMapLabelsSat)
        if (this.baseMapLabelsHyb) this.map.removeLayer(this.baseMapLabelsHyb)

        if (fab) fab.close();

        //console.log("REGION: ", this.selected_region);

        /* ************************************************ */
        /* ********************** ARCTIC ****************** */
        /* ************************************************ */
        if (this.selected_region === "ARCTIC") {

            //this.map.options.crs = this.getCrs();

            // let url = "http://arcticgeoservices.org/arcgis/services/public/Arctic_Base_Map/MapServer/WMSServer?"
            // let url = "http://geoserver.myocean.eu/geoserver/wms?"
            // let layers = "cls:noaa_blue_marble_north_pole_no_ocean"
            // layers: "cls:noaa_blue_marble",
            // layers:"cls:noaa_blue_marble_no_ocean",
            // layers: "cls:noaa_blue_marble_north_pole",

            let url = "https://gis.ngdc.noaa.gov/arcgis/services/arctic_ps/arctic_basemap/MapServer/WmsServer?"
            let layers = "0"

            switch (type) {
                case 'hyb':
                case 'sat':
                    this.baseMapSat = L.tileLayer.wms(url, {
                        layers: layers,
                        // version: '1.1.1',
                        format: 'image/png',
                        transparent: true,
                        //continuousWorld: false,
                        // noWrap: false,
                    });
                    this.map.addLayer(this.baseMapSat, true);
                    break;
            }

            this.map.setView([90, 0], 5);

        }

        /* ************************************************ */
        /* ****************** NON ARCTIC ****************** */
        /* ************************************************ */
        else {

            // this.map.options.crs = L.CRS.EPSG3857

            let baseMaps = this.consts.BaseMaps;
            // Def Sat
            let sat = baseMaps.ESRI_sat
            this.baseMapSat = esri.basemapLayer(sat.name);
            // Def Hyb
            let hyb = baseMaps.ESRI_hyb
            this.baseMapHyb = esri.basemapLayer(hyb.name);
            // Def Sat Labels
            let lbl_sat = baseMaps.ESRI_lbl_sat
            this.baseMapLabelsSat = esri.basemapLayer(lbl_sat.name);
            // Def Sat Labels
            let lbl_hyb = baseMaps.ESRI_lbl_hyb
            this.baseMapLabelsHyb = esri.basemapLayer(lbl_hyb.name);

            // Set Basemap
            switch (type) {
                case 'sat':
                    this.map.addLayer(this.baseMapSat, true);
                    this.map.addLayer(this.baseMapLabelsSat, true);
                    this.baseMapSat.bringToBack();
                    break;
                case 'hyb':
                    this.map.addLayer(this.baseMapHyb, true);
                    this.map.addLayer(this.baseMapLabelsHyb, true);
                    this.baseMapHyb.bringToBack();
                    break;
                default:
                    this.map.addLayer(this.baseMapSat, true);
                    this.map.addLayer(this.baseMapLabelsHyb, true);
                    this.baseMapSat.bringToBack();
                    break;
            }
        }

        //Add mask layer to non-adri area
        let domainmask = ''
        domainmask = "../assets/data/adrion.geojson"
        // to avoid adding masks everytime the product is changed
        if (!this.masklayer) {
            fetch(domainmask).then(res => res.json()).then(json => {
                // console.log("OUTPUT: ", json);
                this.masklayer = L.geoJSON(json, {
                    invert: true,
                    weight: 1,
                    opacity: 1,
                    color: '#0078A8',
                    dashArray: '3',
                    fillOpacity: 0.3,
                }).addTo(this.map);
            });
        }

        // console.log("SELECTED REGION:", this.selected_region, " PROD_DATE:",this.selected_region_prod_date,"MAP_TYPE:", type);

    }

    /** ****************************************************
     *
     * Set data layers
     *
    ******************************************************* */
    setMap() {
        //console.log("fn() setMap")
        // console.log("SETMAP")
        // if (this.map.hasLayer(this.velocity) || this.velocity) this.map.removeLayer(this.velocity)

        let url = this.consts.WMSServerURL
        this.mapfile = ''

        this.selected_layers_1 = this.selected_variable_1 ? this.selected_variable_1.name : null
        this.selected_layers_2 = this.selected_variable_2 ? this.selected_variable_2.name : null
        this.selected_layers_3 = this.selected_variable_3 ? this.selected_variable_3.name : null


        // this.selected_layers_1 = this.selected_variable_1 ? (this.selected_region+'_'+this.selected_variable_1.title+'_'+this.selected_depth) : null
        // this.selected_layers_2 = this.selected_variable_2 ? (this.selected_region+'_'+this.selected_variable_2.title+'_'+this.selected_depth) : null
        // this.selected_layers_3 = this.selected_variable_3 ? this.selected_variable_3.name: null


        // --------------------------------------------------------------------------------
        // ONLY in case of TOTAL-SEA-LEVEL
        if (this.selected_variable_1.title == "MEDSEA_20000101_20000101_0000_0_Total-Sea-Level") {
            //console.log(this.selected_variable_1, this.selected_layers_1 )
            // url = "http://193.204.199.193/cache/mapsrvn8/"  // DA ELIMINARE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            //this.selected_layers_1 = "MEDSEA_20000101_20000101_0000_0_Total-Sea-Level"
            //this.mapfile = this.conn.stations_mapfile
            this.mapfile = '/srv/ov/backend/mapfiles/cascade/CASCADE.map';

            //console.log(this.conn.stations_mapfile);

            this.wmsLayer1 = L.tileLayer.wms(url, {
                layers: this.selected_layers_1,
                version: '1.3.0',
                crs: L.CRS.EPSG3857,
                tms: false,
                format: 'image/png',
                transparent: true,
                errorTileUrl: 'assets/img/error.png',
                attribution: '<a href="http://www.cmcc.it">CMCC</a>',
                // noWrap: true, // duplica il dato spostandosi con PAN sui globi multipli
            });
            this.wmsLayer1.setParams({
                map: this.mapfile,
                // COLORSCALERANGE: colorscalerange,
                worldCopyJump: true,
                continuousWorld: false,
            });
            this.map.eachLayer((layer) => {
                if (layer._url != undefined) {
                    // layer da non rimuovere
                    if (layer._url.indexOf('mapcache') != -1 || layer._url.indexOf('dataset-topaz4-arc-myoceanv2-be') != -1 || layer._url.indexOf(this.consts.WMSServerURL) != -1 || layer._url.indexOf('mapsrvn8') != -1) {
                        this.addLayerToList(layer)
                    }
                }
            })
            this.wmsLayer1.on('load', () => {
                // console.log("layer wmsLayer1 loaded");
                this.wmsLayer1loaded = true
                this.clearLayers()
                // this.debug();
            });
            this.map.addLayer(this.wmsLayer1);
            if (this.mapfile && this.selected_variable_1) this.updateColorbar("SetMap")
        }
        // --------------------------------------------------------------------------------
        // ALL layers other then TOTAL-SEA-LEVEL
        else {

            // Def WMS1
            // this.mapfile = this.mapfilesdir
            // this.mapfile = this.mapfile.concat(this.selected_region);
            // this.mapfile = this.mapfile.concat('.map');

            //this.mapfile = this.mapfilesdir + 'APP.map';
            this.mapfile = '/srv/ov/backend/mapfiles/cascade/CASCADE.map';

            // let layers = this.selected_layers_1 // + '_' + this.selected_depth
            // layers = this.selected_layers_2 ? layers +','+ this.selected_region + '_' + this.selected_layers_2 + '_' + this.selected_depth: layers
            // layers = this.selected_layers_3 ? layers +','+ this.selected_region + '_' + this.selected_layers_3 + '_' + this.selected_depth: layers

            let layers = this.selected_layers_1
            layers = this.selected_layers_2 ? layers + ',' + this.selected_layers_2 : layers
            layers = this.selected_layers_3 ? layers + ',' + this.selected_layers_3 : layers

            this.wmsLayer1 = L.tileLayer.wms(url, {
                layers: layers, //this.selected_layers_1+','+this.selected_layers_2+','+this.selected_layers_3,
                version: '1.3.0',
                crs: L.CRS.EPSG3857,
                tms: false,
                format: 'image/png',
                transparent: true,
                errorTileUrl: 'assets/img/error.png',
                attribution: '<a href="http://www.cmcc.it">CMCC</a>',
                // noWrap: true, // duplica il dato spostandosi con PAN sui globi multipli
            });

            //console.log("*info* Selected timestep value", this.selected_timestep.value)
            let time = moment(this.selected_timestep.value, 'YYYYMMDD HH')
            //let time = moment('2022-03-20T00:00:00Z', 'YYYYMMDD HH');
            this.wmsLayer1.setParams({
                map: this.mapfile,
                // COLORSCALERANGE: colorscalerange,
                worldCopyJump: true,
                continuousWorld: false,
                time: time.format('YYYY-MM-DDTHH:00:00'),   //'2021-10-05T00:00:00Z'
            });

            this.map.eachLayer((layer) => {
                if (layer._url != undefined) {
                    // layer da non rimuovere
                    if (layer._url.indexOf('mapcache') != -1 || layer._url.indexOf('dataset-topaz4-arc-myoceanv2-be') != -1 || layer._url.indexOf(this.consts.WMSServerURL) != -1 || layer._url.indexOf('mapsrvn8') != -1) {
                        this.addLayerToList(layer)
                    }
                }
            })

            if (this.selected_variable_1) this.map.addLayer(this.wmsLayer1);

            // this.colorbar_params = 'orientation=' + this.dev_orientation + '&t=cbar&var=' + this.selected_variable_1 + '&min=' + this.min + '&max=' + this.max + '&unit=' + this.unit;
            // this.colorbar_URL = this.consts.ColorbarURL + '?' + this.colorbar_params;
            if (this.mapfile && this.selected_variable_1) this.updateColorbar("SetMap")
            //console.log(this.colorbar_URL);

            let show_err: boolean = true;

            this.wmsLayer1.on('tileerror', function (error: any, tile: any) {
                //console.log("error: ", error,tile);
                if (show_err) {
                    console.log("*info* Error retrieving tiles: ", error, tile);
                    //alert("Invalid response. Please, verify the request parameters!");
                    show_err = false;
                }
            });

            this.wmsLayer1.on('load', () => {
                // console.log("layer wmsLayer1 loaded");
                this.wmsLayer1loaded = true
                this.clearLayers()
                // this.debug();
            });

            if (this.selected_variable_1.title == "Currents" && this.selected_curr_type == 'animated') {
                this.removeCurrentsAnimationLayer();
                this.setCurrentsAnimationLayer();
            }

        }


    }


    /** ****************************************************
     *
     * removeCurrentsAnimationLayer
     *
    ******************************************************* */
    removeCurrentsAnimationLayer() {
        //console.log("fn() removeCurrentsAnimationLayer")
        if (this.velocity) {
            this.map.removeLayer(this.velocity)
            this.velocity = null
        }
    }


    /** ****************************************************
     *
     * setCurrentsAnimationLayer
     *
    ******************************************************* */
    setCurrentsAnimationLayer() {
        //console.log("fn() setCurrentsAnimationLayer")
        let _that = this;



        let png_url = null
        let lo1 = 0
        let la1 = 0
        let lo2 = 0
        let la2 = 0
        let particleMultiplier = 1 / 300
        let lineWidth = 2

        switch (_that.selected_region) {
            case "GOFS":
                lo1 = -181.3  //-179;
                la1 = -90; //-89,  //-90
                lo2 = 178.7; //179.9375  // 180
                la2 = 90    //89.9375; // 90
                particleMultiplier = 0.4 / 100;
                lineWidth = 1.8;
                break;
            case "MEDSEA":
                lo1 = -17.29167 // -18.251016 -.7
                la1 = 30.1875   // 29.289199 +.6
                lo2 = 36.29167  // 38.174765 -.7
                la2 = 45.97917  // 45.636856 +.6
                particleMultiplier = 1 / 300
                lineWidth = 1.5
                break
            case "SAVANNAH":
                lo1 = -81.55
                la1 = 31.06
                lo2 = -80.26
                la2 = 32.58
                particleMultiplier = 0.4 / 300
                lineWidth = 2
                break
            case "BLKSEA":
                lo1 = 27.37
                la1 = 40.86
                lo2 = 41.96259
                la2 = 46.80444
                particleMultiplier = 1 / 300
                lineWidth = 1.5
                break
            case "DUBAI":
                lo1 = 54.6
                la1 = 24.83
                lo2 = 55.51
                la2 = 25.69
                particleMultiplier = 0.4 / 100
                lineWidth = 1.8
                break
            case "TARANTO":
                lo1 = 16.3968
                la1 = 39.0055
                lo2 = 18.4000
                la2 = 40.6500
                particleMultiplier = 1 / 300
                lineWidth = 2
                break


            default:
                lo1 = -180
                la1 = -90
                lo2 = 180
                la2 = 90
                particleMultiplier = 1 / 300
                lineWidth = 2
        }

        // URL to png image
        png_url = _that.consts.pngURL + _that.selected_region + '/' + _that.current_day + '_' + _that.current_time + '_' + '07_' + _that.selected_depth + '_h.png'


        // https://fetch.spec.whatwg.org/
        fetch(png_url).then(function (resp) {
            return resp.arrayBuffer()
        }).then(function (buffer) {
            // https://github.com/vivaxy/png

            if (buffer.byteLength < 300) return

            const metadata = png_decoder.decode(buffer);

            let u_min = parseFloat(metadata.text.u_min)
            let u_incr = parseFloat(metadata.text.u_incr)
            let v_min = parseFloat(metadata.text.v_min)
            let v_incr = parseFloat(metadata.text.v_incr)

            let height = metadata.height
            let width = metadata.width
            let pngdata = metadata.data

            let numberPoints = pngdata.length / 4 / 2
            let u_data = []
            let v_data = []

            for (let i = 0; i < pngdata.length; i += 4 * 3) { // 4-->RGBA
                // u_data
                if (i < numberPoints * 4) {    // 4-->RGBA 
                    let min = u_min
                    let incr = u_incr
                    u_data.push((pngdata[i] * incr) + min);
                    u_data.push((pngdata[i + 1] * incr) + min);
                    u_data.push((pngdata[i + 2] * incr) + min);
                }
                // v_data
                else {
                    let min = v_min
                    let incr = v_incr
                    v_data.push(((pngdata[i] * incr) + min));
                    v_data.push(((pngdata[i + 1] * incr) + min));
                    v_data.push(((pngdata[i + 2] * incr) + min));
                }
            }

            let nx = width
            let ny = height / 2
            let dx = (lo2 - lo1) / nx
            let dy = (la2 - la1) / ny * -1

            let u_part = [], v_part = [], JSONdata = []
            let u_header_str = '{"surface1Type": 160, "scanMode": 0, "disciplineName": "Oceanographic_products", "shape": 0, "significanceOfRT": 0, "parameterNumberName": "U_component_of_current", "la1": ' + la1 + ', "la2": ' + la2 + ', "discipline": 10, "lo2": ' + lo2 + ', "significanceOfRTName": "Analysis", "surface1Value": 15, "centerName": "Earth & Space Research", "shapeName": "Earth spherical with radius = 6,367,470 m", "surface1TypeName": "Depth below sea level", "nx": ' + nx + ', "ny": ' + ny + ', "lo1": ' + lo1 + ', "parameterNumber": 2, "dx": ' + dx + ', "dy": ' + dy + ', "parameterCategoryName": "Currents", "parameterCategory": 1, "numberPoints": ' + numberPoints + ', "center": -3, "parameterUnit": "m.s-1", "forecastTime": 0, "refTime": "2014-01-31T00:00:00.000Z"}';
            u_part['header'] = JSON.parse(u_header_str);
            u_part['data'] = u_data;
            JSONdata[0] = u_part;

            let v_header_str = '{"surface1Type": 160, "scanMode": 0, "disciplineName": "Oceanographic_products", "shape": 0, "significanceOfRT": 0, "parameterNumberName": "V_component_of_current", "la1": ' + la1 + ', "la2": ' + la2 + ', "discipline": 10, "lo2": ' + lo2 + ', "significanceOfRTName": "Analysis", "surface1Value": 15, "centerName": "Earth & Space Research", "shapeName": "Earth spherical with radius = 6,367,470 m", "surface1TypeName": "Depth below sea level", "nx": ' + nx + ', "ny": ' + ny + ', "lo1": ' + lo1 + ', "parameterNumber": 3, "dx": ' + dx + ', "dy": ' + dy + ', "parameterCategoryName": "Currents", "parameterCategory": 1, "numberPoints": ' + numberPoints + ', "center": -3, "parameterUnit": "m.s-1", "forecastTime": 0, "refTime": "2014-01-31T00:00:00.000Z"}';
            v_part['header'] = JSON.parse(v_header_str);
            v_part['data'] = v_data;
            JSONdata[1] = v_part;

            let mask_url = _that.consts.masksURL + _that.selected_region + '.geojson'

            d3.json(mask_url, function (data) {
                try {
                    _that.map.removeLayer(_that.velocity)
                }
                catch (e) {
                    // console.log(e)
                }

                _that.velocity = L.velocityLayer({
                    // canvas: L.DomUtil.create('canvas', 'leaflet-layer'),
                    displayValues: false,
                    displayOptions: {
                        velocityType: 'Velocity',
                        position: 'bottomleft',          //REQUIRED !
                        emptyString: 'No velocity data', //REQUIRED !
                        angleConvention: 'bearingCW',
                        displayPosition: 'bottomright',
                        displayEmptyString: 'No velocity data',
                        speedUnit: 'm/s'
                    },
                    data: JSONdata,
                    _mask: data,   //null,   //,       //pbfLayer,   //  data,   //pbf,        //   _that.mask, ,  // layer, // 
                    _map: _that.map,
                    // OPTIONAL
                    // minVelocity: -10,        // used to align color scale
                    // maxVelocity: 10,         // used to align color scale
                    velocityScale: 0.25,         // modifier for particle animations, arbitrarily defaults to 0.005
                    //colorScale: ["rgb(255,255,255)"],
                    colorScale: ["rgb(120,120,120)"], //colorScale: ["rgb(100,100,100)"],//["rgb(104,104,104)"],   // define your own array of hex/rgb colors
                    // onAdd: function(){
                    //     console.log("onAddonAddonAdd")
                    // },                // callback function
                    // onRemove: null,             // callback function
                    particleDensity: 100,
                    opacity: 1,                 // default 0.097,
                    lineWidth: lineWidth,
                    frameRate: 15,              // default 15
                    particleAge: 55,            // default 64
                    particleMultiplier: particleMultiplier   // default  1 / 300
                });

                _that.velocity.addTo(_that.map)

            })

        }).catch(e => console.log("something went wrong: " + e));

    }

    /** ****************************************************
     *
     * Convert to ISO date
     *
    ******************************************************* */
    stringDateToISOdate(stringDate) {
        //console.log("fn() stringDateToISOdate", stringDate)
        let date = stringDate.substr(0, 4) + '-' + stringDate.substr(4, 2) + '-' + stringDate.substr(6, 2) + ' ' + stringDate.substr(9, 2) + ':00'
        let dateObj = new Date(date);
        return dateObj.toISOString();
    }

    /** ****************************************************
     *
     * 
     *
     ******************************************************* */
    daysBetween(startDate, endDate) {
        //console.log("fn() daysBetween", startDate, endDate)
        let d1 = new Date(startDate);
        let d2 = new Date(endDate);
        let days = Math.floor((d2.getTime() - d1.getTime()) / (1000 * 3600 * 24));
        return days;
    }

    /** ****************************************************
     *
     * add layers to the list to be removed
     *
    ******************************************************* */
    addLayerToList(layer: any) {
        //console.log("fn() addLayerToList", layer)
        //console.log("addLayerToList: ", layer)
        this.layers_to_remove.push(layer)
    }

    /** ****************************************************
     *
     * remove layers in the list
     *
    ******************************************************* */
    clearLayers() {
        //console.log('fn() clearLayers')
        // return;
        //if(layer._url.indexOf('mapcache') != -1)
        this.layers_to_remove.forEach((layer: any) => {
            this.cutLayers(layer);
        });
    }

    /** ****************************************************
     *
     * remove single layer
     *
    ******************************************************* */
    cutLayers(layer: any) {
        //console.log('fn() cutLayers', layer)
        //console.log("PRE layers_to_remove array: ",this.layers_to_remove);
        var idx = this.layers_to_remove.indexOf(layer);
        //console.log("Index to remove: ", layer._leaflet_id, idx, layer.options.layers);
        this.layers_to_remove.splice(idx, 1);
        // console.log("removing layer: ",layer);
        this.map.removeLayer(layer)
        //console.log("POST layers_to_remove array: ",this.layers_to_remove);
    }

    /** ****************************************************
     *
     * Present Regions popup
     * @param event
     *
    ******************************************************* */
    presentRegions(event: any) {
        //console.log("fn() presentRegions", event)
        //console.log(event);
        let popover = this.popoverCtrl.create(RegionsPage,
            {
                "regions": this.regions,
                "selected": this.selected_region,
                cssClass: "custom-popover"
            }
        );
        popover.onDidDismiss((data) => {
            //console.log('Data back Region: ', data);
            if (data) this.onRegionChange(data.region);
        });
        popover.present({
            ev: event
        });
    }

    /** ****************************************************
     * Present Variables popup
     * @param event
    ******************************************************* */
    presentVariables(event: any) {
        //console.log("fn() presentVariables")
        //console.log(event);
        let var_ocean: any = []
        let var_meteo: any = []
        this.variables[0].layers.forEach(element => {
            // console.log("element: ", element)
            if (element.type == "meteo") var_meteo.push(element)
            else var_ocean.push(element) //type is ocean
        });

        let popover = this.popoverCtrl.create(VariablesPage,
            {
                "variables_ocean": var_ocean,
                "variables_meteo": var_meteo,
                "selected": this.selected_variable_1,
            }
        );
        popover.onDidDismiss((data) => {
            // console.log('Data back Variable: ', data);
            if (data) {
                // this.selected_curr_type = data.selected_curr_type
                this.onVariableChange(data.selected_variable, data.selected_curr_type);
            }
        });
        popover.present({
            ev: event
        });
    }

    /** ****************************************************
     *
     * Present Depths popup
     * @param event
     *
    ******************************************************* */
    presentDepth(event: any) {
        //console.log("fn() presentDepth")
        let popover = this.popoverCtrl.create(DepthPage,
            {
                "depths": this.depths,
                "selected": this.selected_depth,
            }
        );
        popover.onDidDismiss((data) => {
            if (data) this.onDepthChange(data.depth);
        });
        popover.present({
            ev: event
        });
    }

    /** ****************************************************
     *
     * Present popup
     * @param event
     *
    ******************************************************* */
    showPaletteOptions(event: any) {
        //console.log("fn() showPaletteOptions")
        console.log("*info* this.minBeforeDynpal: ", this.minBeforeDynpal)
        console.log("*info* this.min: ", this.min)
        console.log("*info* this.customMinPal: ", this.customMinPal)

        let popover = this.popoverCtrl.create(PalettePage,
            {
                "dynpal": this.dynpal,
                "dynpal_auto": this.dynpal_auto,
                "custom_min": this.min, //this.minBeforeDynpal,
                "custom_max": this.max //this.maxBeforeDynpal
            }
        );
        popover.onDidDismiss((data) => {
            if (data) {
                console.log("*info* showPaletteOptions-->>> ", data)
                this.dynpal = data.dynpal
                this.dynpal_auto = data.dynpal_auto
                if (data.dynpal_auto == false) {
                    this.customMinPal = +data.custom_min
                    this.customMaxPal = +data.custom_max
                    //this.max = data.custom_max
                } else {
                    this.customMinPal = null//+this.minBeforeDynpal
                    this.customMaxPal = null//+this.maxBeforeDynpal
                }
                this.setdynpal(null);
            }
        });
        popover.present({
            ev: event
        });
    }


    /** ****************************************************
     *
     * Open external page (in-app browser)
     * @param event
     *
    ******************************************************* */
    openPage(url: string) {
        this.iab.create(url);
    }


    /** ****************************************************
     *
     * Open external page (in-app browser)
     * @param event
     *
    ******************************************************* */
    sortJSONArrayByName(value1, value2) {
        return ((value1.name == value2.name) ? 0 : ((value1.name > value2.name) ? 1 : -1));
    }





}

function convertString(name: String) {
    return name.replace(/_/g, ": ").replace(/-/g, " ")
}

function crop(url, aspectRatio) {
    // we return a Promise that gets resolved with our canvas element
    return new Promise((resolve) => {
        // this image will hold our source image data
        const inputImage = new Image();

        // we want to wait for our image to load
        inputImage.onload = () => {
            // let's store the width and height of our image
            const inputWidth = inputImage.naturalWidth;
            const inputHeight = inputImage.naturalHeight;

            // get the aspect ratio of the input image
            const inputImageAspectRatio = inputWidth / inputHeight;

            // if it's bigger than our target aspect ratio
            let outputWidth = inputWidth;
            let outputHeight = inputHeight;
            if (inputImageAspectRatio > aspectRatio) {
                outputWidth = inputHeight * aspectRatio;
            } else if (inputImageAspectRatio < aspectRatio) {
                outputHeight = inputWidth / aspectRatio;
            }

            // calculate the position to draw the image at
            const outputX = (outputWidth - inputWidth) * 0.5;
            const outputY = (outputHeight - inputHeight) * 0.5;

            // create a canvas that will present the output image
            const outputImage = document.createElement('canvas');

            // set it to the same size as the image
            outputImage.width = outputWidth;
            outputImage.height = outputHeight;

            // draw our image at position 0, 0 on the canvas
            const ctx = outputImage.getContext('2d');
            ctx.drawImage(inputImage, outputX, outputY);
            resolve(outputImage);
        };

        // start loading our image
        inputImage.src = url;
    });
}


// WEBPACK FOOTER //
// ./src/pages/home/home.ts